import { PaymentData } from 'projects/services/PaymentData';

interface PaymentModal {
    isAvailable: boolean;
    show: (paymentInput: PaymentData) => void;
}

interface Payments {
    paymentModal: PaymentModal;
}

interface PaymentWindow extends Window {
    payments: Payments;
}

// Mimic the constants set in payments
// https://github.com/99designs/payments/blob/6a53abf5feea4f7ac4a4f347585773bc6e4a8700/assets/js/utils/constants.js
const VENDOR_EVENT_SEND_APP_VISIBLE = 'Payments.app.visible';
const VENDOR_EVENT_SEND_PAYMENT_SUCCESS = 'Payments.vendor.paymentSuccess';
const VENDOR_EVENT_SEND_PAYMENT_FAILURE = 'Payments.vendor.paymentFailure';

export interface PaymentServiceConfig {
    paymentInput: PaymentData;
    onSuccess: () => void;
    onFailure: () => void;
    onVisible: () => void;
}

// Listens to the events sent from payments and provides an interface for
// executing handlers on payment events.
export default class PaymentService {
    private config: PaymentServiceConfig;

    constructor(config: PaymentServiceConfig) {
        this.config = config;
        this.initEventListeners();
    }

    showModal() {
        this.paymentsModal.show(this.config.paymentInput);
    }

    destroy() {
        this.removeEventListeners();
    }

    private initEventListeners() {
        window.addEventListener(VENDOR_EVENT_SEND_APP_VISIBLE, this.config.onVisible);
        window.addEventListener(VENDOR_EVENT_SEND_PAYMENT_SUCCESS, this.config.onSuccess);
        window.addEventListener(VENDOR_EVENT_SEND_PAYMENT_FAILURE, this.config.onFailure);
    }

    private removeEventListeners() {
        window.removeEventListener(VENDOR_EVENT_SEND_APP_VISIBLE, this.config.onVisible);
        window.removeEventListener(VENDOR_EVENT_SEND_PAYMENT_SUCCESS, this.config.onSuccess);
        window.removeEventListener(VENDOR_EVENT_SEND_PAYMENT_FAILURE, this.config.onFailure);
    }

    private get paymentsModal() {
        const paymentWindow = window as PaymentWindow;

        if (
            paymentWindow.payments &&
            paymentWindow.payments.paymentModal &&
            paymentWindow.payments.paymentModal.isAvailable
        ) {
            return paymentWindow.payments.paymentModal;
        } else {
            throw Error('Payment modal not found on window object');
        }
    }
}
